// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LinkProjectResponse
 */
export interface LinkProjectResponse {
  /**
   *
   * @type {string}
   * @memberof LinkProjectResponse
   */
  projectID?: string;
}

/**
 * Check if a given object implements the LinkProjectResponse interface.
 */
export function instanceOfLinkProjectResponse(
  value: object,
): value is LinkProjectResponse {
  return true;
}

export function LinkProjectResponseFromJSON(json: any): LinkProjectResponse {
  return LinkProjectResponseFromJSONTyped(json, false);
}

export function LinkProjectResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LinkProjectResponse {
  if (json == null) {
    return json;
  }
  return {
    projectID: json['projectID'] == null ? undefined : json['projectID'],
  };
}

export function LinkProjectResponseToJSON(json: any): LinkProjectResponse {
  return LinkProjectResponseToJSONTyped(json, false);
}

export function LinkProjectResponseToJSONTyped(
  value?: LinkProjectResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    projectID: value['projectID'],
  };
}
